import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover } from "antd";
import { Loading3QuartersOutlined, SoundOutlined, MutedOutlined, CloseOutlined } from "@ant-design/icons";
import { useI18n } from "components/I18nProvider";
import styles from './style.module.scss';
export const TtsPopover = ({ open, onOpenChange, ttsStatus, onAudioToggle, language, children }) => {
    const { intl } = useI18n();
    const handleAudioToggle = () => {
        if (ttsStatus === 'n/a' || ttsStatus === 'waiting' || ttsStatus === 'stopped') {
            return;
        }
        onAudioToggle(ttsStatus === 'on' ? 'off' : 'on');
    };
    const isOn = ttsStatus === 'on';
    const isWaiting = ttsStatus === 'waiting';
    const isUnavailable = ttsStatus === 'n/a' || ttsStatus === 'stopped';
    const languageName = language.trim() === ''
        ? ''
        : intl.formatMessage({ id: language, defaultMessage: language });
    const description = {
        on: intl.formatMessage({ id: 'ttsDescOn' }),
        off: intl.formatMessage({ id: 'ttsDescOff' }),
        waiting: intl.formatMessage({ id: 'ttsDescWaiting' }),
        'n/a': intl.formatMessage({ id: 'ttsDescNA' }),
        stopped: intl.formatMessage({ id: 'ttsDescNA' }),
    }[ttsStatus];
    const buttonLabel = isOn
        ? intl.formatMessage({ id: 'voiceOff' })
        : intl.formatMessage({ id: 'voiceOn' });
    const buttonIcon = isWaiting
        ? _jsx(Loading3QuartersOutlined, { spin: true })
        : isOn
            ? _jsx(MutedOutlined, {})
            : _jsx(SoundOutlined, {});
    const content = (_jsxs("div", { className: styles.popoverContent, children: [_jsxs("div", { className: styles.header, children: [_jsxs("div", { className: styles.headerLeft, children: [_jsx("span", { className: styles.titleIcon, children: isOn ? (_jsxs("span", { className: styles.statusWaveLg, children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })) : isWaiting ? (_jsx(Loading3QuartersOutlined, { spin: true })) : isUnavailable ? (_jsx(MutedOutlined, {})) : (_jsx(SoundOutlined, {})) }), _jsx("span", { className: styles.title, children: intl.formatMessage({ id: 'ttsTitle' }) })] }), _jsx("button", { className: styles.closeButton, onClick: () => onOpenChange(false), "test-id": "subtitles-tts-popover-close-button", children: _jsx(CloseOutlined, {}) })] }), _jsx("p", { className: styles.description, children: description }), (isOn || isWaiting || ttsStatus === 'off') && (_jsxs("div", { className: styles.languageRow, children: [_jsx("span", { className: styles.languageLabel, children: intl.formatMessage({ id: 'ttsLanguage' }) }), _jsx("span", { className: styles.languageValue, children: languageName })] })), _jsxs("button", { "test-id": "subtitles-tts-popover-toggle-button", className: `${styles.toggleButton} ${isOn ? styles.buttonOn : ''}`, onClick: handleAudioToggle, disabled: isUnavailable || isWaiting, children: [buttonIcon, !isWaiting && buttonLabel] })] }));
    return (_jsx(Popover, { content: content, trigger: "click", open: open, onOpenChange: onOpenChange, getPopupContainer: (triggerNode) => triggerNode.closest('[data-theme]') ?? document.body, overlayInnerStyle: {
            backgroundColor: 'var(--subs-theme-color-bg-secondary)',
            border: '1px solid var(--subs-theme-color-border)',
            borderRadius: '0.75rem',
            padding: '1.5rem',
            boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
        }, rootClassName: "tts-popover-root", overlayStyle: { padding: 0 }, children: children }));
};
export default TtsPopover;
